import type { Hero, ThemeName } from '../types';

type ReportSection = { title: string; lines: string[]; symbol: string };
type ReportDetail = { metricNotes: Record<string, string>; sections: ReportSection[]; destinyLine: string };

const pilotDetails: Record<number, ReportDetail> = {
  1: {
    metricNotes: {
      偏爱浓度: '他的偏爱克制却清晰，会把你的选择和尊严始终放在关系中央。',
      守护行动力: '真正遇到危险时，他会站到离你最近的位置，也会为你保留决定权。',
      情绪理解力: '他更习惯先解决问题；把感受说清楚，能让他的行动真正接住你的需要。',
      心动危险值: '这段关系更像稳定并肩，而不是失控拉扯，心动里仍保留着清醒和边界。',
    },
    sections: [
      {
        title: '为什么偏偏是他',
        symbol: '锋',
        lines: [
          '你想要的从来不是一个替你做主的英雄，而是一个足够强大、却仍尊重你选择的人。',
          '谢征会在危险时先站到前面，也会把决定权交还给你。你匹配到他，说明你渴望的不是被拯救，而是被认真地当作同伴。',
        ],
      },
      {
        title: '他为什么会被你吸引',
        symbol: '契',
        lines: [
          '最打动他的，是你明明能够独自前行，却仍愿意看见他的疲惫。',
          '别人仰望他的身份和能力，你却能在需要他时坦然依靠，也能在他撑不住时说一句“这次换我”。这种平等会让他真正动心。',
        ],
      },
      {
        title: '他会怎样爱你',
        symbol: '守',
        lines: [
          '他的爱不算热闹，却会在关键处变得非常清楚。',
          '他会替你留退路、在麻烦发生时及时出现，也会在别人替你做决定前先问你的意思。他给你的不是牢笼，而是并肩作战的底气。',
        ],
      },
      {
        title: '你们最甜的名场面',
        symbol: '景',
        lines: [
          '你已经准备独自面对最难的一局，一回头，却发现他早已站在身边。',
          '他不问你怕不怕，只把需要的东西递过来，淡淡说一句：“走。”那一刻你会明白，最好的偏爱，是他知道你能打，也愿意陪你上场。',
        ],
      },
      {
        title: '最大槽点',
        symbol: '盾',
        lines: [
          '他的责任感太重，很多事情都习惯先处理、结束后再告诉你。',
          '他以为这是减少你的风险，你感受到的却可能是被隔在他的世界之外。',
        ],
      },
      {
        title: '你们最容易为什么吵架',
        symbol: '结',
        lines: [
          '你们最容易争执的不是爱不爱，而是为什么重要的事你总是最后才知道。',
          '你需要知情和共同决定，他却认为只要保证你安全，就没必要让你承受过程中的危险。',
        ],
      },
      {
        title: '相处建议',
        symbol: '莲',
        lines: [
          '要和他走远，需要重新定义“保护”：告诉真相不是增加负担，共同承担也不是让你独自冒险。',
          '你也要在他最强之外看见他的疲惫。主动问一句“你是不是也很累”，会让这个习惯当承重墙的人第一次觉得自己可以回家。',
        ],
      },
    ],
    destinyLine: '真正适合你的人，会在你准备独自杀出去时，把刀递给你，然后和你站到同一边。',
  },
  20: {
    metricNotes: {
      偏爱浓度: '他把所有的温柔都给了你，你是他心底最柔软的存在。',
      守护行动力: '他会为你挡下世间风雨，用行动默默守护你的安全。',
      情绪理解力: '他能读懂你没说出口的情绪，却常把感受藏在心底。',
      心动危险值: '越靠近他，越容易沦陷，明知危险，却无法退场。',
    },
    sections: [
      {
        title: '为什么偏偏是他',
        symbol: '月',
        lines: [
          '你反复想起的，往往不是最热烈直白的人，而是那个表面疏离、内里极深的人。',
          '你会匹配到相柳，是因为你要的不是轻飘飘的示好，而是一个明明不说，却会在关键时刻替你挡下风雨的人。',
        ],
      },
      {
        title: '他为什么会被你吸引',
        symbol: '缘',
        lines: [
          '最吸引他的，不是你的顺从或依赖，而是你受过伤后仍愿意认真生活的力量。',
          '你让一个习惯了责任、宿命和失去的人，第一次开始想象：原来人生也可以有“以后”。',
        ],
      },
      {
        title: '他会怎样爱你',
        symbol: '守',
        lines: [
          '他的爱并不张扬，也很少把你挂在嘴边。',
          '可真正重要的事情上，他几乎都会站在你这边，替你铺路、挡风险。很多你平安走过的时刻，背后其实都有他。',
        ],
      },
      {
        title: '你们最甜的名场面',
        symbol: '景',
        lines: [
          '所有人都以为那是你一个人的局，你也做好了独自扛下来的准备。',
          '走到最难处时，你一回头，发现他已经站在那里。他不解释，也不邀功，只淡淡说一句：“走吧。”',
        ],
      },
      {
        title: '最大槽点',
        symbol: '裂',
        lines: [
          '他最大的优点，也是最大的缺点：太能忍，也太会藏。',
          '他宁愿一个人扛下所有事情，自以为是在保护你，却很容易让你觉得自己始终被隔在外面。',
        ],
      },
      {
        title: '你们最容易为什么吵架',
        symbol: '结',
        lines: [
          '你因为他什么都不说而不安，他又因为怕你受牵连而继续沉默。',
          '你们的问题往往不是不爱，而是爱得太克制，最终把关系变成一场猜谜。',
        ],
      },
      {
        title: '相处建议',
        symbol: '莲',
        lines: [
          '不要逼他立刻变成一个热烈、善于表达的人，但要让他明白：分享风险，并不等于把负担丢给你，而正是彼此并肩的开始。',
          '重要的事要说，真实的需要也要回应。只有让爱被看见，沉默的守护才不会被误解成疏离。',
        ],
      },
    ],
    destinyLine: '他不是最会留下来的那个人，却可能是替你挡掉最多事情、又最不想让你知道的人。',
  },
  23: {
    metricNotes: {
      偏爱浓度: '他的目光一旦落在你身上，世界里便再难容下旁人。',
      守护行动力: '他会用近乎决绝的方式挡在你身前，不给命运第二次伤害你的机会。',
      情绪理解力: '他在学习辨认爱与不安，也在学习听懂你没有说完的话。',
      心动危险值: '越靠近越无法抽身，爱意与占有往往只隔着一线。',
    },
    sections: [
      { title: '为什么偏偏是他', symbol: '月', lines: ['你心里仍藏着一个愿望：被一个人爱得足够确定、足够坚定。', '他的炽烈让你无法旁观，也让你看见感情最不加掩饰的重量。'] },
      { title: '他为什么会被你吸引', symbol: '劫', lines: ['你的纯粹与善意，像一束不灭的光，照进他千年不见天日的深渊。', '你没有把他当成天生的恶，也没有因为他的锋利放弃看见他。'] },
      { title: '他会怎样爱你', symbol: '焰', lines: ['为你打破原则，颠覆世界；', '偏爱写在每一次孤注一掷里；', '把你刻进灵魂，绝不允许失去。'] },
      { title: '你们最甜的名场面', symbol: '景', lines: ['血月之下，他以命相护，轻声命名：', '“这一世，你归我了，谁也带不走。”'] },
      { title: '你们最大的挑战', symbol: '链', lines: ['他的黑暗本性与你的光明信念，始终是你们彼此救赎、亦是最大的考验。', '当“我不能失去你”变成“所以你不能离开我”，爱就会失去边界。'] },
      { title: '你们最容易为什么吵架', symbol: '结', lines: ['他越是不安，越想把一切牢牢抓住；', '你越需要空间，越会被他的失控推远。'] },
      { title: '相处建议', symbol: '莲', lines: ['给他足够的信任与安全感；', '直面他的阴影，而非试图改变；', '并肩前行，成为彼此时唯一的光芒。'] },
    ],
    destinyLine: '我生来便是为了你。这一世，我不做神，只做你的烬。',
  },
};

type ThemeExpansion = {
  why: string;
  attracted: string;
  love: string;
  sweet: string;
  challenge: string;
  conflict: string;
  advice: string;
};

const themeExpansions: Record<ThemeName, ThemeExpansion> = {
  清冷仙系: {
    why: '你被打动的不是遥不可及的冷，而是那份冷淡之下只对少数人显露的柔软。',
    attracted: '你不急着闯进他的世界，也不把沉默当作拒绝，这份分寸感让他愿意慢慢靠近。',
    love: '他的爱不会喧哗，却会落在长久的记得、克制的照顾和一次次没有缺席里。',
    sweet: '真正让你心动的，是他看似什么都没说，却早已把你的感受放进每一个决定。',
    challenge: '疏离感一旦变成习惯，体贴也可能被误读成冷漠，双方都容易在沉默里错过彼此。',
    conflict: '你想确认自己被坚定选择，他却更习惯用不打扰来表达珍惜，于是越在意越说不清。',
    advice: '不必逼他突然热烈，但要约定重要的事及时说、真实的需要不靠猜。',
  },
  温润公子系: {
    why: '你真正想要的不是被强势接管，而是在一段关系里既被照顾，也始终被尊重。',
    attracted: '你能接住他的体面，也看得见从容背后的疲惫，让他不必永远扮演无所不能的人。',
    love: '他的爱会藏进日常秩序里：记得你的习惯、照顾你的体面，也给你足够的选择空间。',
    sweet: '最动人的往往不是盛大的承诺，而是你回头时发现，他已经稳稳接住了那些小事。',
    challenge: '温柔如果总靠克制维持，也会把真实的不满和需要一起藏住，最后变成无声的距离。',
    conflict: '一个觉得不说是体谅，一个却需要明确回应，争执常常从“你应该懂”开始。',
    advice: '把照顾说成需要，把礼貌换成坦白；稳定并不等于永远没有情绪。',
  },
  智谋权谋系: {
    why: '你欣赏的不是算计本身，而是一个人在复杂局面里仍能保持判断、替未来留出余地。',
    attracted: '你不是等待答案的人，而是能听懂他的思路、也敢在关键处提出不同意见的同行者。',
    love: '他会把爱写进计划：提前看见风险、准备退路，再把最稳妥的位置留给你。',
    sweet: '最甜的瞬间，是你以为自己独自面对难题，却发现他的每一套方案里早就有“我们”。',
    challenge: '擅长掌局的人也容易替对方做决定；保护若缺少知情和选择，就会变成控制。',
    conflict: '你在意的是被信任、被告知，他在意的是先把事情解决，双方常把关心说成质问。',
    advice: '让计划透明、让选择共同发生；聪明可以用来托底，不该用来替对方决定人生。',
  },
  铁血将军系: {
    why: '你向往的不是被藏在身后，而是有人承认你的力量，并在真正危险时与你并肩。',
    attracted: '你看得见强硬背后的责任，也不会把他的承担视作理所当然，这让他愿意卸下一部分防备。',
    love: '他表达感情最直接的方式是行动：站到你身边、处理问题、把承诺变成可以依靠的事实。',
    sweet: '真正戳中你的，是所有人都以为你只能独自撑住时，他已经把自己放在离你最近的位置。',
    challenge: '行动力很强的人容易跳过情绪，以为解决事情就等于安抚了你，久而久之会留下委屈。',
    conflict: '你需要先被理解，他却本能地开始处理问题；两个人明明都在关心，却像在说两种语言。',
    advice: '先说感受，再谈方案；并肩不是谁替谁扛，而是风险、决定和脆弱都能共享。',
  },
  危险宿命系: {
    why: '你被吸引的并非危险本身，而是强烈反差里那份只向你显露的认真与失控。',
    attracted: '你没有只爱他的光亮面，也没有轻易被锋利吓退，这种看见让他很难再把你当作过客。',
    love: '他的爱浓度很高，偏爱、保护和占有常常同时出现，每一次靠近都带着不容忽视的重量。',
    sweet: '最甜的地方，是那个对世界充满戒备的人，在你面前第一次愿意交出真实和软肋。',
    challenge: '强烈并不天然等于深情；当不安越过边界，保护、试探与占有会变得难以分辨。',
    conflict: '他越害怕失去越想抓紧，你越感到被控制越想后退，争执便容易变成反复拉扯。',
    advice: '安全感必须和边界一起建立：坦白目的、尊重选择，也允许彼此保留独立空间。',
  },
  鲜活成长系: {
    why: '你需要的不是一个永远完美的人，而是愿意和你一起过真实日子、也愿意继续成长的人。',
    attracted: '你能接住他的玩笑、笨拙或防备，也会认真看见那些没有说出口的努力。',
    love: '他的偏爱很有生活感：陪你解决麻烦、分享狼狈，也把普通日子过出只属于你们的默契。',
    sweet: '真正让你记住的，是再混乱的时刻里，他依然有办法让你笑出来，然后陪你把事情做完。',
    challenge: '轻松感有时也会遮住深层情绪；一句“没事”或一个玩笑，可能让真正的问题被延后。',
    conflict: '你想认真确认关系，他却习惯先把气氛变轻，越想靠近时越容易觉得对方没有听见。',
    advice: '保留你们的松弛和幽默，也给重要情绪一个不被玩笑带过的正式时刻。',
  },
};

function describeMetric(label: string, value: number, hero: Hero) {
  const degree = value >= 92 ? '非常鲜明' : value >= 82 ? '稳定而清晰' : value >= 70 ? '会在关键时刻显现' : '需要在相处中慢慢建立';
  const keyword = hero.keywords[label === '偏爱浓度' ? 0 : label === '守护行动力' ? 1 : 2] ?? hero.relation_type;

  if (label === '偏爱浓度') return `他的偏爱${degree}，会把“${keyword}”落实成一次次只对你的选择。`;
  if (label === '守护行动力') return `他的守护${degree}，真正遇到事情时，会用行动让你知道自己不是一个人。`;
  if (label === '情绪理解力') return `他的理解力${degree}；说清感受，会比等待他猜中更容易抵达彼此。`;
  if (label === '心动危险值') return `这段关系的吸引力${degree}，越心动越要同时保留信任、坦白和边界。`;
  return '这是你们关系中最鲜明、也最值得认真看见的一面。';
}

function buildExpandedSections(hero: Hero): ReportSection[] {
  const theme = themeExpansions[hero.theme];
  const [firstKeyword, secondKeyword, thirdKeyword] = hero.keywords;

  return [
    {
      title: '为什么偏偏是他',
      symbol: '缘',
      lines: [hero.why_him, theme.why, `这份匹配真正看重的，是你同时需要“${firstKeyword}”的确定与“${secondKeyword}”的默契。`],
    },
    {
      title: '他为什么会被你吸引',
      symbol: '心',
      lines: [hero.why_attracted, theme.attracted, `在他眼里，你不是等待被安排的人，而是能让“${hero.relation_type}”真正成立的同行者。`],
    },
    {
      title: '他会怎样爱你',
      symbol: '守',
      lines: [hero.how_love, theme.love, `他的“${thirdKeyword}”不会只停在态度上，而会慢慢变成你在关系里能够确认的安全感。`],
    },
    {
      title: '你们最甜的名场面',
      symbol: '景',
      lines: [hero.sweet_scene, theme.sweet, '让你反复想起的不会只是那个场景，而是那一刻你清楚地知道：他站在你这一边。'],
    },
    {
      title: '你们最大的挑战',
      symbol: '裂',
      lines: [hero.flaw, theme.challenge, `当“${firstKeyword}”失去分寸，它也可能变成压力；真正长久的关系需要给彼此选择和呼吸。`],
    },
    {
      title: '你们最容易为什么吵架',
      symbol: '结',
      lines: [hero.conflict, theme.conflict, '争执的核心往往不是那件小事，而是两个人都在追问：我有没有被你真正理解和放在心上？'],
    },
    {
      title: '相处建议',
      symbol: '莲',
      lines: [hero.advice, theme.advice, `把“${firstKeyword}”留给心动，把“${secondKeyword}”落实到沟通，你们的关系才会既有故事，也有以后。`],
    },
  ];
}

export function getReportDetail(hero: Hero): ReportDetail {
  const pilot = pilotDetails[hero.id];
  if (pilot) return pilot;
  return {
    metricNotes: Object.fromEntries(Object.entries(hero.front_cards).map(([label, value]) => [label, describeMetric(label, value, hero)])),
    sections: buildExpandedSections(hero),
    destinyLine: hero.final_line,
  };
}
